module.exports = __webpack_public_path__ + "img/classic_m1.6b4edf75.png";